import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const EmptyHistoryState = ({ hasFilters, onClearFilters }) => {
  if (hasFilters) {
    return (
      <div className="text-center py-12">
        <div className="flex items-center justify-center w-16 h-16 bg-muted rounded-full mx-auto mb-4">
          <Icon name="Search" size={24} className="text-muted-foreground" />
        </div>
        
        <h3 className="font-heading font-semibold text-foreground mb-2">
          No entries match your filters
        </h3>
        
        <p className="text-muted-foreground mb-6 max-w-md mx-auto">
          Try adjusting your search terms or date range to find the entries you're looking for.
        </p>
        
        <Button
          variant="outline"
          iconName="X"
          iconPosition="left"
          onClick={onClearFilters}
        >
          Clear All Filters
        </Button>
      </div>
    );
  }

  return (
    <div className="text-center py-12">
      <div className="flex items-center justify-center w-16 h-16 bg-primary/10 rounded-full mx-auto mb-4">
        <Icon name="Calendar" size={24} className="text-primary" />
      </div>
      
      <h3 className="font-heading font-semibold text-foreground mb-2">
        No history entries yet
      </h3>
      
      <p className="text-muted-foreground mb-6 max-w-md mx-auto">
        Start setting your daily goals and tracking your CORE4 progress. Your history will appear here as you build your routine.
      </p>
      
      <div className="flex flex-col sm:flex-row gap-3 justify-center">
        <Button
          asChild
          variant="default"
          iconName="Target"
          iconPosition="left"
        >
          <Link to="/today">Set Today's Goals</Link>
        </Button>
        
        <Button
          asChild
          variant="outline"
          iconName="BarChart3"
          iconPosition="left"
        >
          <Link to="/stats">View Statistics</Link>
        </Button>
      </div>
    </div>
  );
};

export default EmptyHistoryState;